"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Instagram, Music2, Mail, ArrowRight } from "lucide-react";
export default function TheRoster() {
  const artists = [{
    name: "DJ Madame Velvet",
    bio: "A pioneer of the Michigan underground scene, Madame Velvet blends cinematic techno with high-energy EDM rock. Her performances are known for their immersive atmosphere and relentless rhythm.",
    email: "contact@heavenshorizonsrecords.com",
    instagram: "https://instagram.com",
    soundcloud: "https://soundcloud.com",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689432/img/artifact_img_0ib1v1mz.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689432/img/artifact_img_0ib1v1mz.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689432/img/artifact_img_0ib1v1mz.png-wvc-sizes"
  }, {
    name: "Ethan Heaven",
    bio: "Fusing soulful country pop melodies with futuristic bass production, Ethan Heaven creates a soundscape that bridges the gap between Nashville and the digital horizon.",
    email: "contact@heavenshorizonsrecords.com",
    instagram: "https://instagram.com",
    soundcloud: "https://soundcloud.com",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689432/img/artist_ethan.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689432/img/artist_ethan.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689432/img/artist_ethan.png-wvc-sizes"
  }];
  return <section data-section-id="223460" id="the-roster" className="bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-accent/50 to-transparent opacity-40" />
      <div className="absolute top-0 left-1/4 w-px h-full bg-gradient-to-b from-secondary/10 to-transparent opacity-10" />
      <div className="absolute -bottom-48 -right-48 size-[600px] bg-accent/10 blur-[120px] rounded-lg" />
      <div className="absolute -top-48 -left-48 size-[600px] bg-secondary/10 blur-[120px] rounded-lg" />
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="mb-20 text-center md:text-left">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-accent/10 border border-accent/20 mb-6">
            <span className="size-2 rounded-lg bg-accent animate-pulse" />
            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-accent">Artist Archive</span>
          </div>
          <h2 className="font-default text-5xl md:text-7xl font-black uppercase tracking-tighter text-foreground mb-6 leading-none">
            Meet the <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent to-secondary">Roster</span>
          </h2>
          <p className="font-default text-lg text-muted-foreground max-w-2xl leading-relaxed">
            Discover the visionaries pushing the boundaries of EDM, Pop, and Rock under the Heavens Horizons banner.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {artists.map((artist, i) => <Card key={i} data-index={i} className="rounded-lg border-white/5 bg-card/20 backdrop-blur-2xl overflow-hidden transition-all duration-500 hover:border-accent/40 group shadow-2xl">
              <div className="relative h-48 overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-t from-card via-transparent to-transparent z-10" />
                
                <div className="absolute bottom-6 left-6 z-20">
                  <div className="flex items-center gap-2 text-secondary text-[10px] uppercase tracking-widest font-bold mb-2">
                    <span className="size-1.5 rounded-lg bg-secondary animate-pulse" />
                    Active Artist
                  </div>
                  <CardTitle className="font-default text-4xl uppercase tracking-tighter text-foreground group-hover:text-accent transition-colors">
                    {artist.name}
                  </CardTitle>
                </div>
              </div>

              <CardContent className="space-y-6 pt-6">
                <p className="font-default text-base text-muted-foreground leading-relaxed">
                  {artist.bio}
                </p>
                
                <div className="flex flex-wrap items-center gap-6">
                  <div className="flex items-center gap-3 text-xs font-mono text-accent/80">
                    <Mail className="size-4" />
                    {artist.email}
                  </div>
                  <div className="flex gap-3">
                    <Link to={artist.instagram} newTab className="p-2.5 rounded-lg bg-white/5 border border-white/10 hover:bg-secondary/20 hover:border-secondary/50 transition-all">
                      <Instagram className="size-5 text-foreground" />
                    </Link>
                    <Link to={artist.soundcloud} newTab className="p-2.5 rounded-lg bg-white/5 border border-white/10 hover:bg-accent/20 hover:border-accent/50 transition-all">
                      <Music2 className="size-5 text-foreground" />
                    </Link>
                  </div>
                </div>
              </CardContent>

              <CardFooter className="pb-8">
                <Link to="/ArtistsPage" className="w-full">
                  <Button variant="outline" className="w-full h-12 rounded-lg border-accent/30 hover:bg-accent/10 hover:text-accent uppercase tracking-widest text-xs font-bold group/btn">
                    View Full Profile
                    <ArrowRight className="size-4 ml-2 transition-transform group-hover/btn:translate-x-1" />
                  </Button>
                </Link>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}